import React from 'react';
import { Link } from 'react-router-dom';
import { formatCurrency, formatCycle } from '../utils';

// Tom neutro (mesmo cinza do thead-light) pra marcar linhas que divergem
// entre os planos comparados. Nada de amber/warning aqui: variação entre
// planos não é um erro, então a cor não deve soar como alerta.
const DIFF_BG = '#F3F6F9';
const DIFF_BORDER = '#B5B5C3';

const stickyColumnStyle = {
  position: 'sticky',
  left: 0,
  background: '#fff',
  zIndex: 1,
  minWidth: 220,
};

const stickyDiffColumnStyle = {
  ...stickyColumnStyle,
  background: DIFF_BG,
  borderLeft: `2px solid ${DIFF_BORDER}`,
};

export function PlanComparisonTable({ plans, rows }) {
  return (
    <div className="card card-custom mt-2">
      <div className="card-header py-3 min-h-auto">
        <h3 className="card-title mb-0">Comparativo de planos</h3>
      </div>
      <div className="card-body table-responsive">
        {plans.length === 0 ? (
          <p className="text-muted mb-0">
            Marque "Incluir no comparativo" em ao menos um plano acima.
          </p>
        ) : (
          <table className="table table-sm table-bordered table-hover mb-0">
            <caption className="sr-only">
              Comparativo de itens incluídos em cada plano
            </caption>
            <thead className="thead-light">
              <tr>
                <th
                  scope="col"
                  style={{ ...stickyColumnStyle, verticalAlign: 'bottom' }}
                >
                  Item
                </th>
                {plans.map((plan) => (
                  <th scope="col" key={plan.id} className="text-nowrap">
                    {plan.name}
                    <div
                      className="font-weight-normal"
                      style={{ lineHeight: 1.4 }}
                    >
                      <span className="text-primary font-weight-bolder">
                        {formatCurrency(plan.amount)}
                      </span>{' '}
                      <span className="text-muted">
                        · {formatCycle(plan.cycleDays)}
                      </span>
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr
                  key={row.code}
                  style={row.diff ? { backgroundColor: DIFF_BG } : undefined}
                >
                  <th
                    scope="row"
                    className="font-weight-normal"
                    style={row.diff ? stickyDiffColumnStyle : stickyColumnStyle}
                  >
                    <div className="d-flex align-items-center" style={{ gap: 6 }}>
                      <Link
                        to={`/payments/items/${row.id}`}
                        className="text-muted"
                        aria-label={`Ver detalhes de ${row.name}`}
                        title="Ver detalhes"
                      >
                        <i className="flaticon-eye" style={{ fontSize: '0.85rem' }} />
                      </Link>
                      <span>{row.name}</span>
                      {row.diff && (
                        <span
                          className="text-muted font-weight-bolder"
                          style={{ fontSize: '0.75rem' }}
                          role="img"
                          aria-label="Difere entre os planos comparados"
                          title="Difere entre os planos comparados"
                        >
                          ≠
                        </span>
                      )}
                    </div>
                  </th>
                  {plans.map((plan) => (
                    <td
                      key={plan.id}
                      className={row.values[plan.id] ? '' : 'text-muted'}
                    >
                      {row.values[plan.id] || '—'}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
